import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useMe } from '../hooks';

export function RequireAuth({ children }: { children: ReactElement }) {
  const location = useLocation();
  const { data: session, isPending, isError } = useMe();

  if (isPending) {
    return <div className="content muted">Проверяем сессию…</div>;
  }

  if (isError || !session) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
}
